import { CartAddEvent } from '@theme/events';
class WWShippingCompanion extends HTMLElement {
 connectedCallback(){
   if(this.isDismissed()){this.hidden=true;return;}
   this.addEventListener('click',this.onClick);
   this.validate();
   document.addEventListener('cart:update', this.onCartUpdated);
   document.addEventListener('discount:update', this.onCartUpdated);
 }
 disconnectedCallback(){this.removeEventListener('click',this.onClick);document.removeEventListener('cart:update',this.onCartUpdated);document.removeEventListener('discount:update',this.onCartUpdated)}
 isDismissed(){try{return sessionStorage.getItem('ww-shipping-dismiss')===this.dataset.cartSignature}catch{return false}}
 onCartUpdated=()=>this.validate();
 async validate(){
   try{
     const root=window.Shopify?.routes?.root||'/';
     const response=await fetch(root+'cart.js');
     if(!response.ok)throw new Error('Unable to verify');
     const cart=await response.json();
     if(cart.total_discount<=0||cart.original_total_price<7500||cart.total_price>=7500)this.hidden=true;
   }catch{this.hidden=true}
 }
 onClick=async(event)=>{
   if(event.target.closest('.ww-free-ship__dismiss')){
     try{sessionStorage.setItem('ww-shipping-dismiss',this.dataset.cartSignature)}catch{};this.hidden=true;return;
   }
   const button=event.target.closest('[data-ww-add]');
   if(!button||button.disabled)return;
   const id=Number(button.dataset.wwAdd);
   if(!Number.isSafeInteger(id))return;
   if(this.adding)return;
   this.adding=true;
   let added=false;
   const status=this.querySelector('.ww-free-ship__feedback');
   button.disabled=true;button.textContent='Adding…';
   try{
     const root=window.Shopify?.routes?.root||'/';
     const sections=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(e=>e.dataset.sectionId))];
     const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1}],sections,sections_url:location.pathname})});
     const data=await response.json();
     if(!response.ok)throw new Error(data.description||'Cannot add item');
     added=true;
     const cartResponse=await fetch(root+'cart.js');
     if(!cartResponse.ok)throw new Error('Unable to refresh cart');
     const cart=await cartResponse.json();
     document.dispatchEvent(new CartAddEvent(cart,'ww-shipping-companion',{source:'ww-shipping-companion',itemCount:cart.item_count,sections:data.sections||{},variantId:String(id)}));
     if(!sections.length || !data.sections || sections.some(sectionId=>!data.sections[sectionId]))window.location.reload();
     await this.validate();
     if(status){status.hidden=false;status.textContent='Added to cart. Your discount and shipping eligibility will be recalculated.'}
   }catch(e){
     if(added){window.location.reload();return;}
     if(status){status.hidden=false;status.textContent=e.message||'Unable to add. Please try again.'}
     button.disabled=false;button.textContent='Add to bag';
   }finally{this.adding=false}
 }
}
if(!customElements.get('ww-shipping-companion'))customElements.define('ww-shipping-companion',WWShippingCompanion);
